import { UserWithLoyaltyWrapper } from './styles';
import { User } from '../user';
import { HeaderModelData } from 'types/model';
import { WithAuthProps } from 'components/header/hoc';
import { WithLoginB2B } from 'components/header/components/profile/root';
import React from 'react';
import { IPointAndRank, PointAndRank } from './points-and-rank/point-and-rank';

interface IUserWithLoyalty extends WithAuthProps, WithLoginB2B, IPointAndRank {
  model: HeaderModelData;
}

export const QA_LOYALTY_USER_WITH_LOYALTY = 'QA_LOYALTY_USER_WITH_LOYALTY';

export const UserWithLoyalty: React.FC<IUserWithLoyalty> = ({
  model,
  points,
  pointsLoading,
  rankLabel,
  rankLoading,
  proCard,
  ...authProps
}) => {
  return (
    <UserWithLoyaltyWrapper data-qa={QA_LOYALTY_USER_WITH_LOYALTY}>
      <User model={model} {...authProps} />
      <PointAndRank
        points={points}
        pointsLoading={pointsLoading}
        rankLabel={rankLabel}
        rankLoading={rankLoading}
        proCard={proCard}
      />
    </UserWithLoyaltyWrapper>
  );
};
